import React, { useEffect, useState } from 'react';
import { Eye, Image, EyeOff, X, Link2 } from 'react-feather';
import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

import api from '../../services/api'

import CardPost from '../CardPost';
import Button from '../Button';
import defaultImage from '../../assets/default.jpg'
import './style.css';

function Feed() {
    const error = (msg) => toast.error(msg, { autoClose: 3000 });

    const [isCreatingPost, setIsCreatingPost] = useState(false);

    const [posts, setPosts] = useState([])
    const [isOpen, setIsOpen] = useState(false);

    const [url_image, setUrlImage] = useState('')
    const [previewUrl, setpreviewUrl] = useState('')
    const [text, setText] = useState('')

    const [visible, setVisible] = useState(true)
    const [isLoadedImage, setIsLoadedImage] = useState(false)

    function changeVisible() {
        visible ? setVisible(false) : setVisible(true)
    }

    function show() {
        return isOpen ? 'block' : 'none'
    }

    async function create() {
        const id_user = 1
        const data = { id_user, text, url_image, visible }

        if (data.text === '' && data.url_image === '') {
            return error('texto está vázio.')
        }

        setIsCreatingPost(true)

        setTimeout(() => {
            setPosts(prev => [...prev, data])
            setIsCreatingPost(false)
            removeImageFromPost()
        }, 2000);
    }

    function addImageToPost() {
        if (isLoadedImage) {
            setUrlImage(previewUrl)
            closeModal()
        }
    }

    function removeImageFromPost() {
        setUrlImage('')
    }

    function openModal() {
        setIsOpen(true)
    }


    function closeModal() {
        setIsOpen(false)
        setpreviewUrl('')
        setIsLoadedImage(false)
    }

    useEffect(() => {
        async function getImage() {
            if (previewUrl.trim().length > 0) {
                await api.get(previewUrl)
                    .then(() => setIsLoadedImage(true))
                    .catch(() => setIsLoadedImage(false))
            }
        }

        getImage()
    }, [previewUrl])

    toast.configure()

    return (
        <>
            <div className="modal-fade" style={{ display: show() }}>
                <div className="modal-upload-container">
                    <div className="modal-title">
                        <h1>Adicionar imagem</h1>
                        <button type='button' onClick={closeModal}>
                            <X height="20" width="20" strokeWidth={2.5} />
                        </button>
                    </div>
                    <div className="modal-image-preview">
                        {isLoadedImage ?
                            <img src={previewUrl} alt="Imagem de preview" />
                            :
                            <div className='empty-preview'>
                                <img src={defaultImage} alt="avatar" />
                                <span>Preview</span>
                            </div>
                        }
                    </div>
                    <div className="input-url">
                        <Link2 height="24" width="24" strokeWidth={2.5} />
                        <input type="url" value={previewUrl} onChange={e => setpreviewUrl(e.target.value)} placeholder='Link da imagem' />
                    </div>

                    <Button type={'button'} onClick={() => addImageToPost()} loading={isCreatingPost} text="Adicionar">
                        Publicar
                    </Button>
                </div>
            </div>

            <div className="feed">
                <div className="create-post-area">
                    <div className="create-post-top">
                        <h1>Criar uma publicação</h1>
                    </div>
                    <textarea placeholder='Escreva aqui' value={text} onChange={e => setText(e.target.value)}></textarea>
                    {url_image &&
                        (<div className="post-image-preview">
                            <img src={url_image} alt="" />
                            <button onClick={() => removeImageFromPost()} type='button'>Remover</button>
                        </div>
                        )}
                    <div className="create-post-options">
                        <button onClick={changeVisible}>
                            {visible ?
                                <Eye height="20" width="20" strokeWidth={2.5} />
                                :
                                <EyeOff height="20" width="20" strokeWidth={2.5} />
                            }
                            {visible ? 'Publico' : 'Privado'}
                        </button>
                        <button className='add-image' onClick={() => openModal()}>
                            <Image height="20" width="20" strokeWidth={2.5} />
                        </button>
                    </div>
                    <Button type={'button'} onClick={() => create()} loading={isCreatingPost} text="Publicar" />
                </div>

                {
                    posts.map(p => (
                        <CardPost
                            key={1}
                            user_id={1}
                            name="Matheus José"
                            url_avatar="https://avatarfiles.alphacoders.com/128/128984.png"
                            url_image={p.url_image}
                            post_id={1}
                            text={p.text}
                            visible={p.visible}
                            created_at="2023-04-02 17:16:20"
                            liked={false}
                        />
                    ))
                }

                <CardPost
                    user_id={3}
                    name="Lucia Campos"
                    url_avatar=""
                    url_image=""
                    post_id={14}
                    text="publicação da lucia :)"
                    visible={1}
                    created_at="2023-04-02 17:16:20"
                    liked={false}
                />

                <CardPost
                    user_id={1}
                    name="Matheus José"
                    url_avatar="https://avatarfiles.alphacoders.com/128/128984.png"
                    url_image=""
                    post_id={12}
                    text="testando aqui novamente"
                    visible={1}
                    created_at="2023-03-24 17:23:10"
                    liked={false}
                />

                <CardPost
                    user_id={1}
                    name="Matheus José"
                    url_avatar="https://avatarfiles.alphacoders.com/128/128984.png"
                    url_image=""
                    post_id={11}
                    text="Donec maximus congue tellus, at scelerisque sapien maximus quis. Class aptent taciti sociosqu ad litora torquent per conubia nostra, per inceptos himenaeos. Vestibulum eu nulla ligula. Nam elementum vitae magna vel faucibus. Duis luctus semper neque, vel tristique ligula consectetur et. Phasellus vel tellus at velit lacinia laoreet. Nullam vel felis quis eros iaculis malesuada id quis velit. Suspendisse augue arcu, fermentum id sem sed, interdum tincidunt turpis. Vestibulum ac velit mollis, imperdiet odio in, posuere est. Quisque vel turpis lacus. Curabitur gravida nunc a mauris euismod tempus. Sed molestie molestie est, id porttitor odio auctor varius. Donec luctus, est sed eleifend mattis, nibh turpis tincidunt massa, ac dignissim felis mauris vitae tortor. Proin feugiat neque a sapien elementum varius. "
                    visible={1}
                    created_at="2023-03-09 16:13:21"
                    liked={false}
                />

                <CardPost
                    user_id={1}
                    name="Matheus José"
                    url_avatar="https://avatarfiles.alphacoders.com/128/128984.png"
                    url_image="https://marketplace.canva.com/EAFHzpaWnjU/5/0/1600w/canva-vi…rl-sea-view-city-night-sky-desktop-wallpaper-AgKiUfaluzA.jpg"
                    post_id={10}
                    text="testando texto com imagem"
                    visible={1}
                    created_at="2023-03-09 15:24:55"
                    liked={false}
                />

                <CardPost
                    user_id={1}
                    name="Matheus José"
                    url_avatar="https://avatarfiles.alphacoders.com/128/128984.png"
                    url_image="https://upload.wikimedia.org/wikipedia/commons/2/24/Vista_do_Centro_de_Campinas_SP.JPG"
                    post_id={2}
                    text="testando aqui novamente"
                    visible={1}
                    created_at="2022-12-11 20:58:47"
                    liked={false}
                />

                <CardPost
                    user_id={1}
                    name="Matheus José"
                    url_avatar="https://avatarfiles.alphacoders.com/128/128984.png"
                    url_image=""
                    post_id={1}
                    text="testando post"
                    visible={1}
                    created_at="2022-12-03 21:41:25"
                    liked={false}
                />
            </div>
        </>
    )
}

export default Feed;